import { Collection } from 'modules/core/lib/mobx-rest'

import Gender from 'modules/settings/store/models/Gender'

class Genders extends Collection<Gender> {
  get cacheKey(): string {
    return 'genders'
  }

  model() {
    return Gender
  }
}

const singleton: Genders = new Genders()

export default singleton
